/**
 * The retired setup wizard's remembered step (TMMAPP-0120 item 17, retired by TMMAPP-0141 §B):
 * `tmm_genesis_step:<userId>`. Nothing writes it any more; the session clears it once, on its first
 * successful `/me` read. Storage can be unavailable, so the removal is guarded.
 */
const PREFIX = 'tmm_genesis_step:';

export function clearRetiredSetupStep(userId: number | null): void {
  if (userId === null) return;
  try {
    window.localStorage.removeItem(`${PREFIX}${userId}`);
  } catch {
    // storage unavailable: there is nothing to clear
  }
}
